import { render } from "./public_body.vue?vue&type=template&id=125af739"
import script from "./public_body.vue?vue&type=script&lang=js"
export * from "./public_body.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__